import { NotebookOutlineIcon } from './NotebookOutlineIcon';

/**
 * author: Austin Andrews
 * id 71D72BE3-C04C-40EF-87B7-A08E74045DC0
 * name notebook-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/notebook-outline.svg
 * tags
 */
export const PlannerOutlineIcon = NotebookOutlineIcon;
export default PlannerOutlineIcon